// HKDSE 十二篇範文分類測驗數據
// 用於自動填充測驗表單的系統性數據結構

export const hkdseCategoryQuizData = {
  // A1. 孟子《魚我所欲也》
  'hkdse-a1-mengzi-fish': {
    id: 'hkdse-a1-mengzi-fish',
    title: '孟子《魚我所欲也》',
    author: '孟子',
    dynasty: '戰國',
    category: '議論散文',
    categoryQuizzes: {
      keyPoints: {
        id: 'hkdse-a1-keypoints-quiz',
        title: '重點概念測驗',
        description: '測試對孟子《魚我所欲也》重點概念的理解',
        category: '重點概念',
        difficulty: 'intermediate',
        timeLimit: 300, // 5 minutes
        questions: [
          {
            id: 1,
            question: '孟子《魚我所欲也》中「捨生取義的道德觀念」主要體現在哪裡？',
            type: 'multiple-choice',
            options: [
              '魚和熊掌的選擇',
              '生與義的對比',
              '本心的保持',
              '義利之辨'
            ],
            correct: 1,
            explanation: '孟子以魚和熊掌分別比喻生存與道義，論證道義的價值比生存更高，從而引出捨生取義的道理。',
            points: 10
          },
          {
            id: 2,
            question: '「本心不可失的重要性」在文中如何體現？',
            type: 'multiple-choice',
            options: [
              '賢者能勿喪耳',
              '人皆有之',
              '非獨賢者有是心也',
              '失其本心'
            ],
            correct: 0,
            explanation: '孟子指出雖然本心是每個人都有的，但唯有賢者才不會失去，強調保持本心的重要性。',
            points: 10
          },
          {
            id: 3,
            question: '「義利之辨的哲學思考」的核心是什麼？',
            type: 'multiple-choice',
            options: [
              '物質與精神的對立',
              '個人與集體的利益',
              '道義與生存的選擇',
              '古代與現代的價值觀'
            ],
            correct: 2,
            explanation: '孟子通過義利之辨，強調道義比生存更重要，體現了儒家重義輕利的價值觀。',
            points: 10
          },
          {
            id: 4,
            question: '「比喻論證的運用技巧」在文中主要體現在？',
            type: 'multiple-choice',
            options: [
              '魚和熊掌的比喻',
              '生與義的對比',
              '本心的比喻',
              '義利的比喻'
            ],
            correct: 0,
            explanation: '孟子以魚和熊掌分別比喻生存與道義，生動形象地論證了道義的價值。',
            points: 10
          }
        ]
      },
      argumentationMethods: {
        id: 'hkdse-a1-argumentation-quiz',
        title: '論證手法測驗',
        description: '測試對孟子《魚我所欲也》論證手法的理解',
        category: '論證手法',
        difficulty: 'intermediate',
        timeLimit: 300,
        questions: [
          {
            id: 1,
            question: '孟子在文中主要運用了哪些論證手法？',
            type: 'multiple-choice',
            options: [
              '比喻論證和對比論證',
              '舉例論證和引用論證',
              '類比論證和歸納論證',
              '演繹論證和反證法'
            ],
            correct: 0,
            explanation: '孟子主要運用比喻論證（魚和熊掌比喻生存與道義）和對比論證（生與義的對比）。',
            points: 10
          },
          {
            id: 2,
            question: '「比喻論證」在文中的具體表現是？',
            type: 'multiple-choice',
            options: [
              '以魚比喻生存，以熊掌比喻道義',
              '以本心比喻善良本性',
              '以義利比喻道德選擇',
              '以賢者比喻道德典範'
            ],
            correct: 0,
            explanation: '孟子以魚和熊掌分別比喻生存與道義，生動形象地論證了道義的價值。',
            points: 10
          },
          {
            id: 3,
            question: '「對比論證」在文中如何體現？',
            type: 'multiple-choice',
            options: [
              '生與義的對比',
              '賢者與常人的對比',
              '本心與失心的對比',
              '義與利的對比'
            ],
            correct: 0,
            explanation: '孟子通過生與義的對比，突出道義的價值比生存更高。',
            points: 10
          }
        ]
      },
      writingTechniques: {
        id: 'hkdse-a1-writing-quiz',
        title: '寫作手法測驗',
        description: '測試對孟子《魚我所欲也》寫作手法的理解',
        category: '寫作手法',
        difficulty: 'intermediate',
        timeLimit: 300,
        questions: [
          {
            id: 1,
            question: '孟子在文中運用了什麼寫作手法？',
            type: 'multiple-choice',
            options: [
              '正反立論',
              '層層遞進',
              '首尾呼應',
              '開門見山'
            ],
            correct: 0,
            explanation: '孟子運用正反立論，先正面論述道義的重要性，再反面說明失去本心的危害。',
            points: 10
          },
          {
            id: 2,
            question: '「正反立論」在文中的具體表現是？',
            type: 'multiple-choice',
            options: [
              '先論道義重要，再論失心危害',
              '先論本心善良，再論後天影響',
              '先論賢者品格，再論常人缺失',
              '先論義利之辨，再論實踐方法'
            ],
            correct: 0,
            explanation: '孟子先正面論述道義的價值和本心的重要性，再反面說明失去本心的危害。',
            points: 10
          }
        ]
      },
      rhetoricalDevices: {
        id: 'hkdse-a1-rhetorical-quiz',
        title: '修辭手法測驗',
        description: '測試對孟子《魚我所欲也》修辭手法的理解',
        category: '修辭手法',
        difficulty: 'intermediate',
        timeLimit: 300,
        questions: [
          {
            id: 1,
            question: '孟子在文中運用了哪些修辭手法？',
            type: 'multiple-choice',
            options: [
              '比喻、排比、設問',
              '對偶、誇張、反語',
              '借代、象徵、對比',
              '擬人、排比、設問'
            ],
            correct: 0,
            explanation: '孟子主要運用比喻（魚和熊掌）、排比（非禮勿視等）、設問（如使人之所欲莫甚於生）等修辭手法。',
            points: 10
          },
          {
            id: 2,
            question: '「比喻」修辭在文中的具體表現是？',
            type: 'multiple-choice',
            options: [
              '以魚比喻生存，以熊掌比喻道義',
              '以本心比喻善良本性',
              '以賢者比喻道德典範',
              '以義利比喻道德選擇'
            ],
            correct: 0,
            explanation: '孟子以魚和熊掌分別比喻生存與道義，生動形象地表達了道義的價值。',
            points: 10
          },
          {
            id: 3,
            question: '「排比」修辭在文中的具體表現是？',
            type: 'multiple-choice',
            options: [
              '非禮勿視，非禮勿聽，非禮勿言，非禮勿動',
              '魚，我所欲也，熊掌，亦我所欲也',
              '生亦我所欲也，義亦我所欲也',
              '萬鍾則不辯禮義而受之'
            ],
            correct: 0,
            explanation: '「非禮勿視，非禮勿聽，非禮勿言，非禮勿動」運用了排比修辭，四個「非禮勿」的句式整齊，語氣強烈。',
            points: 10
          },
          {
            id: 4,
            question: '「設問」修辭在文中的具體表現是？',
            type: 'multiple-choice',
            options: [
              '如使人之所欲莫甚於生，則凡可以得生者，何不用也？',
              '使人之所惡莫甚於死者，則凡可以辟患者，何不為也？',
              '萬鍾於我何加焉？',
              '是亦不可以已乎？'
            ],
            correct: 0,
            explanation: '孟子運用設問修辭，通過反問的方式強調道義的重要性，增強論證的說服力。',
            points: 10
          }
        ]
      }
    }
  },

  // A2. 荀子《勸學》（節錄）
  'hkdse-a2-xunzi-learning': {
    id: 'hkdse-a2-xunzi-learning',
    title: '荀子《勸學》（節錄）',
    author: '荀子',
    dynasty: '戰國',
    category: '議論散文',
    categoryQuizzes: {
      keyPoints: {
        id: 'hkdse-a2-keypoints-quiz',
        title: '重點概念測驗',
        description: '測試對荀子《勸學》重點概念的理解',
        category: '重點概念',
        difficulty: 'intermediate',
        timeLimit: 300,
        questions: [
          {
            id: 1,
            question: '荀子《勸學》的中心論點是什麼？',
            type: 'multiple-choice',
            options: [
              '學不可以已',
              '青出於藍而勝於藍',
              '君子博學而日參省乎己',
              '積善成德，而神明自得'
            ],
            correct: 0,
            explanation: '荀子開篇就提出「學不可以已」的主論點，強調學習不能停止。',
            points: 10
          },
          {
            id: 2,
            question: '「學習改變人性的作用」在文中如何體現？',
            type: 'multiple-choice',
            options: [
              '青，取之於藍，而青於藍',
              '冰，水為之，而寒於水',
              '木直中繩，輮以為輪',
              '君子博學而日參省乎己'
            ],
            correct: 0,
            explanation: '荀子以「青，取之於藍，而青於藍」等比喻說明學習能夠改變人的本質。',
            points: 10
          },
          {
            id: 3,
            question: '「專心致志的學習態度」在文中如何體現？',
            type: 'multiple-choice',
            options: [
              '君子博學而日參省乎己',
              '積善成德，而神明自得',
              '鍥而不捨，金石可鏤',
              '不積跬步，無以至千里'
            ],
            correct: 0,
            explanation: '「君子博學而日參省乎己」體現了專心致志、不斷反省的學習態度。',
            points: 10
          },
          {
            id: 4,
            question: '「積累的重要性」在文中如何體現？',
            type: 'multiple-choice',
            options: [
              '不積跬步，無以至千里',
              '鍥而不捨，金石可鏤',
              '積善成德，而神明自得',
              '君子博學而日參省乎己'
            ],
            correct: 0,
            explanation: '「不積跬步，無以至千里」強調了學習需要日積月累的重要性。',
            points: 10
          }
        ]
      },
      argumentationMethods: {
        id: 'hkdse-a2-argumentation-quiz',
        title: '論證手法測驗',
        description: '測試對荀子《勸學》論證手法的理解',
        category: '論證手法',
        difficulty: 'intermediate',
        timeLimit: 300,
        questions: [
          {
            id: 1,
            question: '荀子在文中主要運用了哪些論證手法？',
            type: 'multiple-choice',
            options: [
              '比喻論證和對比論證',
              '舉例論證和引用論證',
              '類比論證和歸納論證',
              '演繹論證和反證法'
            ],
            correct: 0,
            explanation: '荀子主要運用比喻論證（青出於藍等）和對比論證（學與不學的對比）。',
            points: 10
          },
          {
            id: 2,
            question: '「比喻論證」在文中的具體表現是？',
            type: 'multiple-choice',
            options: [
              '青，取之於藍，而青於藍',
              '冰，水為之，而寒於水',
              '木直中繩，輮以為輪',
              '君子博學而日參省乎己'
            ],
            correct: 0,
            explanation: '荀子以「青，取之於藍，而青於藍」等比喻生動形象地論證學習的作用。',
            points: 10
          },
          {
            id: 3,
            question: '「對比論證」在文中如何體現？',
            type: 'multiple-choice',
            options: [
              '學與不學的對比',
              '專心與不專心的對比',
              '積累與不積累的對比',
              '君子與小人的對比'
            ],
            correct: 0,
            explanation: '荀子通過學與不學的對比，突出學習的重要性和必要性。',
            points: 10
          }
        ]
      },
      writingTechniques: {
        id: 'hkdse-a2-writing-quiz',
        title: '寫作手法測驗',
        description: '測試對荀子《勸學》寫作手法的理解',
        category: '寫作手法',
        difficulty: 'intermediate',
        timeLimit: 300,
        questions: [
          {
            id: 1,
            question: '荀子在文中運用了什麼寫作手法？',
            type: 'multiple-choice',
            options: [
              '層層遞進',
              '正反立論',
              '首尾呼應',
              '開門見山'
            ],
            correct: 0,
            explanation: '荀子運用層層遞進的寫作手法，從學習的意義→作用→態度→方法，逐步深入。',
            points: 10
          },
          {
            id: 2,
            question: '「層層遞進」在文中的具體表現是？',
            type: 'multiple-choice',
            options: [
              '從學習意義到學習方法',
              '從正面論證到反面論證',
              '從理論闡述到實踐指導',
              '從個體學習到群體學習'
            ],
            correct: 0,
            explanation: '荀子從學習的意義開始，逐步論述學習的作用、態度和方法，形成層層遞進的結構。',
            points: 10
          }
        ]
      },
      rhetoricalDevices: {
        id: 'hkdse-a2-rhetorical-quiz',
        title: '修辭手法測驗',
        description: '測試對荀子《勸學》修辭手法的理解',
        category: '修辭手法',
        difficulty: 'intermediate',
        timeLimit: 300,
        questions: [
          {
            id: 1,
            question: '荀子在文中運用了哪些修辭手法？',
            type: 'multiple-choice',
            options: [
              '對比、比喻、排比、對偶、借代',
              '設問、誇張、反語、擬人',
              '象徵、借代、對比、排比',
              '比喻、排比、設問、對偶'
            ],
            correct: 0,
            explanation: '荀子主要運用對比、比喻、排比、對偶、借代等修辭手法。',
            points: 10
          },
          {
            id: 2,
            question: '「對比」修辭在文中的具體表現是？',
            type: 'multiple-choice',
            options: [
              '青，取之於藍，而青於藍',
              '冰，水為之，而寒於水',
              '木直中繩，輮以為輪',
              '君子博學而日參省乎己'
            ],
            correct: 0,
            explanation: '「青，取之於藍，而青於藍」運用了對比修辭，突出學習的作用。',
            points: 10
          },
          {
            id: 3,
            question: '「排比」修辭在文中的具體表現是？',
            type: 'multiple-choice',
            options: [
              '青，取之於藍，而青於藍；冰，水為之，而寒於水',
              '木直中繩，輮以為輪，其曲中規',
              '君子博學而日參省乎己，則知明而行無過矣',
              '積善成德，而神明自得'
            ],
            correct: 0,
            explanation: '「青，取之於藍，而青於藍；冰，水為之，而寒於水」運用了排比修辭，增強表達效果。',
            points: 10
          },
          {
            id: 4,
            question: '「對偶」修辭在文中的具體表現是？',
            type: 'multiple-choice',
            options: [
              '君子博學而日參省乎己',
              '積善成德，而神明自得',
              '鍥而不捨，金石可鏤',
              '不積跬步，無以至千里'
            ],
            correct: 0,
            explanation: '「君子博學而日參省乎己」運用了對偶修辭，句式整齊，節奏鏗鏘。',
            points: 10
          }
        ]
      }
    }
  }
};

// 輔助函數
export const getCategoryQuizData = (textId) => {
  return hkdseCategoryQuizData[textId] || null;
};

export const getCategoryQuizByType = (textId, categoryType) => {
  const textData = hkdseCategoryQuizData[textId];
  if (!textData) return null;
  
  const categoryMap = {
    'keyPoints': 'keyPoints',
    'argumentationMethods': 'argumentationMethods', 
    'writingTechniques': 'writingTechniques',
    'rhetoricalDevices': 'rhetoricalDevices'
  };
  
  return textData.categoryQuizzes[categoryMap[categoryType]] || null;
};

export const getAllCategoryQuizData = () => {
  return hkdseCategoryQuizData;
}; 